module.exports = __webpack_public_path__ + "img/6s.de662c72.png";